export const isSupabaseConfigured = true;
const API_BASE = import.meta.env.VITE_API_URL ? import.meta.env.VITE_API_URL.replace('/api', '') : '';

/**
 * Нормализует URL для файлов (аватарки, вложения чата и т.д.)
 * Все файлы хранятся локально в /uploads/ на сервере API.
 * 
 * /uploads/file.jpg → /uploads/file.jpg (nginx отдаёт напрямую)
 * https://...supabase.co/storage/v1/object/public/bucket/file.jpg → /uploads/file.jpg
 * https://pvzraschet.ru/uploads/file.jpg → /uploads/file.jpg
 */
export const proxyStorageUrl = (url) => {
  if (!url || typeof url !== 'string') return url;
  
  let base = import.meta.env.VITE_API_URL 
    ? import.meta.env.VITE_API_URL.replace('/api', '') 
    : 'https://pvzraschet.ru';
    
  if (base.startsWith('http://pvzraschet.ru')) {
    base = base.replace('http://', 'https://');
  }
  
  // Если URL содержит старый IP адрес сервера
  if (url.includes('186.246.10.214')) {
    url = url.replace(/https?:\/\/186\.246\.10\.214/, '');
    url = url.replace('186.246.10.214', '');
  }
  
  // Если URL содержит старые ссылки на supabase storage (через supabase-proxy или напрямую)
  if (url.includes('storage/v1/object/public/')) {
    try {
      const idx = url.indexOf('storage/v1/object/public/');
      const path = url.substring(idx);
      return `https://vaktndvzbzgpbjrgacax.supabase.co/${path}?t=20260531_v2`;
    } catch (e) {}
  }
  
  // Локальный путь uploads без косой черты в начале
  if (url.startsWith('uploads/')) {
    return base + '/' + url;
  }
  
  // Уже локальный путь — отдаём с абсолютным доменом
  if (url.startsWith('/uploads')) {
    return base + url;
  }
  
  // Старые supabase storage URL — извлекаем имя файла
  if (url.includes('supabase.co/storage/v1/object/public/')) {
    try {
      const parts = url.split('/storage/v1/object/public/')
      if (parts[1]) {
        // Формат: bucket-name/path/to/file.jpg — берём последнюю часть
        const pathParts = parts[1].split('/')
        const filename = pathParts[pathParts.length - 1]
        if (filename) {
          return `${base}/uploads/${decodeURIComponent(filename)}`
        }
      }
    } catch (e) {
      // fallback — вернём как есть
    }
  }
  
  // Абсолютный URL к нашему серверу — нормализуем под текущий base
  if (url.includes('pvzraschet.ru/uploads/')) {
    try {
      const idx = url.indexOf('/uploads/')
      return base + url.substring(idx)
    } catch (e) {}
  }
  
  // /api/uploads/... (альтернативный маршрут на сервере) — нормализуем
  if (url.startsWith('/api/uploads/')) {
    return base + url.replace('/api/uploads/', '/uploads/')
  }
  
  // Любой другой URL — вернуть как есть (внешние ресурсы, blob: и т.п.)
  try {
    return encodeURI(decodeURI(url));
  } catch (e) {
    return url;
  }
};
// Dummy client to prevent crashes from leftover code
const chainableQuery = {
  select: () => chainableQuery,
  eq: () => chainableQuery,
  neq: () => chainableQuery,
  in: () => chainableQuery,
  or: () => chainableQuery,
  not: () => chainableQuery,
  is: () => chainableQuery,
  gte: () => chainableQuery,
  lte: () => chainableQuery,
  gt: () => chainableQuery,
  lt: () => chainableQuery,
  ilike: () => chainableQuery,
  like: () => chainableQuery,
  contains: () => chainableQuery,
  order: () => chainableQuery,
  limit: () => chainableQuery,
  range: () => chainableQuery,
  insert: () => chainableQuery,
  update: () => chainableQuery,
  delete: () => chainableQuery,
  single: async () => ({ data: null, error: null }),
  maybeSingle: async () => ({ data: null, error: null }),
  then: (resolve) => resolve({ data: [], error: null })
};

const chainableChannel = {
  on: () => chainableChannel,
  subscribe: () => chainableChannel,
  unsubscribe: () => {}
};

export const supabase = {
  auth: {
    onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
    getSession: async () => ({ data: { session: null } })
  },
  channel: () => chainableChannel,
  removeChannel: () => {},
  from: () => chainableQuery,
  rpc: async () => ({ data: null, error: null }),
  storage: {
    from: () => ({
      getPublicUrl: (path) => ({ data: { publicUrl: path } }),
      upload: async () => ({ data: {}, error: null })
    })
  }
};
